// extracted by mini-css-extract-plugin
export default {"wrapper":"Config_wrapper__jFm1U"};